module.exports = __webpack_public_path__ + "08876f412c30edacdd29d0f60cb9ec2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-0.png
// module id = 3201
// module chunks = 0